import React from 'react';

const FieldSet = ({ title, className, children }) => (
    <fieldset className={className || 'custom-fieldset'}>
        <legend>
            <b>{title}</b>
        </legend>
        {children}
    </fieldset>
);

export default FieldSet;
